import React from "react";
import { Col, Row } from "antd";

import Statistics from "./Statistics";
import Transactions from "./Backtest";
import HistoricalChart from "./HistoricalChart";
import PerformanceCharts from "./Backtest/PerformanceCharts";
import FeatureImportance from "./FeatureImportance";

import styles from "./styles.less";

export default () => (
  <Row className={styles.content} gutter={[16, 8]}>
    <Col span={15}>
      <Transactions />
    </Col>
    <Col span={9}>
      <Statistics />
    </Col>
    <Col span={24}>
      <FeatureImportance />
    </Col>
    <Col span={24}>
      <PerformanceCharts />
    </Col>
    <Col span={24}>
      <HistoricalChart />
    </Col>
  </Row>
);
